import React, { useContext, useMemo } from 'react'
import { FormControlLabel, Checkbox, Tooltip } from '@mui/material'
import { LoadingContext } from '../M_Utils'
import { useTranslation } from 'react-i18next'

export function M_CheckBox({ label, checked, icon, checkedIcon, onChange,
    disabled, color, fontSize, required, labelColor, tooltipName, translate }) {
    const ctx = useContext(LoadingContext)
    const { t } = useTranslation()
    color = color ? color : ctx.primaryColor ? ctx.primaryColor : 'var(--color-black)'
    labelColor = labelColor ? labelColor : ctx.secondaryColor ? ctx.secondaryColor : 'var(--color-black)'

    return (
        <span>
            {useMemo(() => <Tooltip title={tooltipName ? tooltipName : ""}>
                <FormControlLabel
                    sx={{
                        margin: !label ? '0px' : '5px 0px',
                        color: labelColor ? labelColor : 'var(--color-black)',
                        '& .MuiSvgIcon-root': { fontSize: fontSize },
                    }}
                    label={translate && t(label) || label}
                    control={
                        <Checkbox
                            checked={checked}
                            disableRipple={true}
                            sx={{
                                color: color ? color : 'var(--color-black)',
                                '&.Mui-checked': {
                                    color: color ? color : 'var(--color-black)',

                                },
                                '& .MuiSvgIcon-root': {
                                    fontSize: fontSize,
                                },
                                '& .Mui-disabled': {
                                    color: 'purple'
                                }

                            }}
                            icon={icon}
                            disabled={disabled}
                            checkedIcon={checkedIcon}
                            onChange={onChange}
                            required={required}
                        />}
                />
            </Tooltip>
                , [tooltipName, label, labelColor, fontSize, checked, icon, disabled, checkedIcon, onChange, required, color])}
        </span>
    )
}